import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import urlParser from "js-video-url-parser/dist/jsVideoUrlParser.js?v=1.2";
import ImageBrowse from "../../../../Common/Image/ImageBrowse";
import { _showToast } from "../../../../../toastHelper";
import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
import NewGallery from "../NewGallery/NewGaller";

const CustomPage = forwardRef(function CustomPage(props, ref) {
  const [expiration, setExpiration] = useState(7);
  const [eventName, setEventName] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [liveUrl, setLiveUrl] = useState("");
  const [errors, setErrors] = useState({});
  const [imageKey, setImageKey] = useState("");
  const thumbnailRef = useRef();

  useEffect(() => {
    resetData();
    if (props.data) {
      setEventDate(props.data.eventDate);
      setEventName(props.data.title);
      setExpiration(props.data.expiration);
      setLiveUrl(props.data.liveUrl);
      setImageKey(props.data.imageKey);
      thumbnailRef?.current?.setThumbnail(props.data.image && props.data.image != "" ? props.data.image : null);
      thumbnailRef?.current?.setFileContent(props.data.imageFile);
    }
  }, [props.data]);

  const resetData = () => {
    setEventDate("");
    setEventName("");
    setExpiration(7);
    setLiveUrl("");
    thumbnailRef?.current?.setThumbnail(null);
    thumbnailRef?.current?.setFileContent(null);
  }

  const validate = () => {
    const errors = {};

    // if (!eventName || (eventName && eventName.trim() == "")) {
    //   errors.eventName = "Phone Number is required";
    // }

    // if (!eventDate || (eventDate && eventDate.trim() == "")) {
    //   errors.eventDate = "Email is required";
    // }

    // if (liveUrl && liveUrl != "") {
    //   let parsedData = urlParser.parse(liveUrl);
    //   if (!(parsedData && parsedData?.id && parsedData.id != "")) {
    //     errors.liveUrl = "Invalid live url";
    //   }
    // }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  }

  const getData = () => {
    return {
      title: eventName,
      eventDate: eventDate,
      image: thumbnailRef?.current?.getThumbnail() ?? null,
      imageFile: thumbnailRef?.current?.getImageFile() ?? null,
      expiration: expiration ?? 7,
      liveUrl: liveUrl,
      imageKey: imageKey
    };
  }

  useImperativeHandle(ref, () => ({
    getData: getData,
    validate: validate
  }));

  return (
    <>
      <div className="content" style={{ display: "block", visibility: "visible" }}>
        <div className="content-header mb-3">
          <div className="sec-titler">
            <h2 className="text-primary">Custom Page</h2>
            <div className="title-shape"></div>
          </div>
        </div>
        <form>
          <div className="row mt-4">
        

            <div className="col-sm-6 mt-3">
              <label className="form-label " htmlFor="dateofevent">
               Page Heading
              </label>
              <textarea 
            //   type="text"
                id="dateofevent"
                name="dateofevent"
                className={`form-control ${errors.eventDate ? "is-invalid" : ""}`}
                data-date-format="dd-mm-yyyy"
                placeholder="Please enter Page Heading Here"
                value={eventDate}
                onChange={(e) => setEventDate(e.target.value)}
              />
            </div>
            <div className="col-sm-6 mt-3" >
              <label className="form-label" htmlFor="liveurl">
                Page Discription
              </label>
              <textarea 
            //   type="text"
                id="liveurl"
                name="liveurl"
                className={`form-control ${errors.liveUrl ? "is-invalid" : ""}`}
                placeholder="Enter Page Discription Here"
                value={liveUrl}
                onChange={(e) => setLiveUrl(e.target.value)}
              />
              {errors.liveUrl && (
                <div className="invalid-feedback">
                  {errors.liveUrl}
                </div>
              )}
            </div>

            <div className="col-sm-6 mt-3">
              <label className="form-label" htmlFor="dateofevent">
           Gallery Title
              </label>
              <input type="text"
                id="dateofevent"
                name="dateofevent"
                className={`form-control ${errors.eventDate ? "is-invalid" : ""}`}
                data-date-format="dd-mm-yyyy"
                placeholder="Please enter Gallery Title profile"
                value={eventDate}
                onChange={(e) => setEventDate(e.target.value)}
              />
            </div>
           <NewGallery></NewGallery>

          </div>
        
          <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate}   />
        </form>
      </div>
    </>
  );
});

export default CustomPage;